<template>
  <div class="BaseSingleSelect">
    <div class="title">{{title}}</div>
    <div
      class="select-ul"
      :class="{oneRow:hide}"
    >
      <div
        class="select-li"
        v-for="(opt,i) in opts"
        :key="i"
        :class="{checked:checked===opt.value}"
        @click="choose(opt.value)"
      >{{opt.name}}
      </div>
      <slot />
    </div>
    <div
      class="expand_text"
      v-if="openExpand"
      @click="changeHide"
    >{{hide?'展开':'缩小'}}</div>

  </div>
</template>

<script>
export default {
  props: { title: String, checked: String, opts: Array, openExpand: Boolean },
  data () {
    return {
      hide: false
    }
  },
  methods: {
    choose (value) {
      this.$emit('update:checked', value)
    },
    changeHide () {
      this.hide = !this.hide
    }
  }
}
</script>

<style lang="scss" scoped>
.BaseSingleSelect {
  display: flex;
  flex-wrap: wrap;
  .title {
    line-height: 31px;
    margin-right: 30px;
    color: #999;
  }
  .select-ul {
    flex: 1;
    width: 0;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    &.oneRow {
      height: 31px;
      overflow: hidden;
    }
    .select-li {
      margin-bottom: 24px;
      margin-right: 24px;
      padding: 6px 12px;
      text-align: center;
      font-size: 14px;
      color: #999;
      cursor: pointer;
      &.checked {
        color: #fff;
        background-color: #347eee;
        border-radius: 10px;
      }
    }
  }
  .expand_text {
    height: 31px;
    line-height: 31px;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/CaliberLibrary/CaliberLibrarySelect.vue